var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"mr-3",attrs:{"icon":"","x-small":""},on:{"click":_vm.toggle}},[_c('v-icon',[_vm._v(_vm._s(_vm.mask ? 'mdi-eye' : 'mdi-eye-off'))])],1),_c('span',[_vm._v(_vm._s(_vm.displayText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }